import config from '@config/config';
import Cookies from 'js-cookie';

import { jwtDecode } from "jwt-decode";
import { proactiveTokenRefresh } from './proactiveTokenRefresh';
import { getIsLoggingOut, setIsLoggingOut } from './tokenRefreshState';

export default{
    logIn(expiry:any,userToken:any,refreshToken:any,userPermissions:any,userId:any,userTypeId:any,sessionId:any,isBenfMigrated:string,isBeneficiaryLogged:boolean,beneficiaryDetails:string, beneficiaryId:string) { 
        setIsLoggingOut(false);
        Cookies.set('expiry',expiry ,{ sameSite:'strict' });
        Cookies.set('user-token',userToken,{ sameSite:'strict' });
        Cookies.set('refresh-token',refreshToken,{ sameSite:'strict' });
        localStorage.setItem('userPermissions', userPermissions);
        localStorage.setItem('userId', userId);
        localStorage.setItem('userTypeId', userTypeId);
        localStorage.setItem('sessionId', sessionId);
        localStorage.setItem('isBenfMigrated',isBenfMigrated); 
        localStorage.setItem('isBeneficiaryLogged',isBeneficiaryLogged.toString());
        localStorage.setItem('beneficiaryDetails',beneficiaryDetails);
        localStorage.setItem('beneficiaryId',beneficiaryId);
        // Start proactive token refresh in background
        if (expiry) {
            proactiveTokenRefresh.startProactiveRefresh(Number(expiry));
        }
      },
      logOut() {
         // Stop proactive token refresh
         proactiveTokenRefresh.stopProactiveRefresh();
         
         Cookies.remove('expiry'); 
         Cookies.remove('user-token');
         Cookies.remove('refresh-token');
         localStorage.removeItem('userPermissions');
         localStorage.removeItem('userId');
         localStorage.removeItem('userTypeId');
         localStorage.removeItem('sessionId');
         localStorage.removeItem('lastActivityTime');
         localStorage.removeItem('userDetails');
         localStorage.removeItem('userImageurl');
         localStorage.removeItem('userDistrictCode');
         localStorage.removeItem('userRoleDetails');
         localStorage.removeItem('userStateCode');
         localStorage.removeItem('userTypeName');
         localStorage.removeItem('isBenfMigrated');
         localStorage.removeItem('reportGenerationTime-pw');
         localStorage.removeItem('childGenderOptions');
         localStorage.removeItem('pregnancyStatusOptions');
         localStorage.removeItem('childMaturityOptions');
         localStorage.removeItem('childRelationOptions');
         localStorage.removeItem('serviceCategoryNonPregnantOptions');
         localStorage.removeItem('serviceCategoryFalseOptions');
         localStorage.removeItem('visitTypeOptions');
         window.sessionStorage.clear();
      },
      refreshFails(){
        if (getIsLoggingOut()) return; // already navigating to /logout, ignore duplicate trigger
            setIsLoggingOut(true);
            proactiveTokenRefresh.stopProactiveRefresh(); // kill the other cycle so it can't race in
            window.location.href = `${config.root?config.root:''}/logout`;
      },
      loggedIn() {
        const headers = Cookies.get('user-token')?{
                headers: {
                  "Authorization": `Bearer ${Cookies.get('user-token')}`,
                  "Content-Type": "application/x-www-form-urlencoded"
                }
              }:{};
        return headers; 
      },
      loggedInWithJSON(){
        const headers = Cookies.get('user-token')?{
          headers: {
            "Authorization": `Bearer ${Cookies.get('user-token')}`,
            "Content-Type": "application/json"
          }
        }:{};
      return headers; 
      },
      loggedInWithMultipart() {
        const headers = Cookies.get('user-token')?{
                headers: {
                  "Authorization": `Bearer ${Cookies.get('user-token')}`,
                  "Content-Type": "multipart/form-data"
                }
              }:{};
        return headers; 
      },
      refreshToken(expiry:any,userToken:any,refreshToken:any,userPermissions:any,userId:any,userTypeId:any) { 
        Cookies.set('expiry',expiry ,{ sameSite:'strict' });
        Cookies.set('user-token',userToken,{ sameSite:'strict' });
        Cookies.set('refresh-token',refreshToken,{ sameSite:'strict' });
        // localStorage.setItem('userPermissions', userPermissions);
        // localStorage.setItem('userId', userId);
        // localStorage.setItem('userTypeId', userTypeId);
        
        // Restart proactive token refresh with new expiry time
        if (expiry) {
            proactiveTokenRefresh.restartRefreshCycle(Number(expiry));
        }
      },
      userId(){
       const user:string = Cookies.get('user-token')!;
        return user?jwtDecode(user):"";
      },

      roledetails(){
        const roleDetails:string = Cookies.get('user-permissions')!;
        return roleDetails;
      }





}